import { render } from "./ProjectSmetaHub.vue?vue&type=template&id=8d73d46c&scoped=true"
import script from "./ProjectSmetaHub.vue?vue&type=script&lang=js"
export * from "./ProjectSmetaHub.vue?vue&type=script&lang=js"

import "./ProjectSmetaHub.vue?vue&type=style&index=0&id=8d73d46c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d73d46c"]])

export default __exports__